import type { VehicleId } from '../../types/gcs/vehicle';
import type { GcsData } from '../../types/gcs/gcsData';

/**
 * Selector to get the MC error description for a vehicle, if any.
 *
 * @param data - The GCS data map from the store
 * @param gcsId - The GCS ID
 * @param vehicleId - The vehicle ID
 * @returns The error description string if non-null, otherwise null/undefined
 */
export function selectVehicleMcErrorDescription(
  data: Map<string, GcsData>,
  gcsId: string,
  vehicleId: VehicleId
): string | null | undefined {
  const gcsData = data.get(gcsId);
  if (!gcsData) return undefined;
  return gcsData.vehicleMissionComputerStatusMap.get(vehicleId)?.errorDescription;
}
